import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import searchSuggestionQuery from '~/graphql/searchSuggestion.gql';
import searchSuggestionAlgoliaQuery from '~/graphql/searchSuggestionAlgolia.gql';
import getCorvusProviderName from '~/helpers/search-data-helpers';
export default {
  props: {
    search: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      results: {},
      loading: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    isAlgoliaCorvusProvider() {
      return getCorvusProviderName(this) === 'algolia';
    },

    getAlgoliaIndex() {
      var {
        algolia
      } = this.$store.state.sharedEnv.payload;
      return algolia;
    }

  }),
  watch: {
    immediate: true,

    search() {
      if (this.search.length === 0) this.results = {};
      this.debounceGetSuggestion();
    }

  },
  methods: {
    debounceGetSuggestion: debounce(function getSuggestions() {
      this.getResults();
    }, 200),

    getResults() {
      if (this.isAlgoliaCorvusProvider) {
        return this.getAlgoliaCorvusSuggestions();
      }

      if (this.isAlgoliaCorvusProvider) {
        return this.getAlgoliaCorvusSuggestions();
      }

      return this.getSuggestions();
    },

    getAlgoliaCorvusSuggestions() {
      var _this = this;

      return _asyncToGenerator(function* () {
        if (!_this.search || _this.search.length < 3) {
          return;
        }

        var algoliaUserToken = _this.$cookies.get('_ALGOLIA') || '';
        _this.loading = true;

        try {
          var {
            data: {
              categorySearchAlgolia,
              productSearchAlgoliaSuggest
            }
          } = yield _this.$apolloProvider.defaultClient.query({
            query: searchSuggestionAlgoliaQuery,
            variables: {
              locale: _this.locale.iso,
              keyword: _this.search,
              offset: 0,
              limit: 5,
              sortBy: 'POPULAR',
              orderBy: 'DEFAULT',
              filterBy: [],
              algoliaUserToken
            }
          });
          _this.loading = false;
          var {
            products,
            total: totalProducts
          } = productSearchAlgoliaSuggest;
          var categories = categorySearchAlgolia;
          var total = products.length + categories.length;
          _this.results = {
            query: _this.search,
            products,
            categories,
            total,
            totalProducts
          };
        } catch (e) {
          _this.loading = false;

          _this.$logger.error(e);
        }
      })();
    },

    getSuggestions() {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        if (!_this2.search || _this2.search.length < 3) {
          return;
        }

        _this2.loading = true;

        try {
          var {
            data: {
              categorySearch,
              productSearchSuggest
            }
          } = yield _this2.$apolloProvider.defaultClient.query({
            query: searchSuggestionQuery,
            variables: {
              locale: _this2.locale.iso,
              keyword: _this2.search,
              offset: 0,
              limit: 5,
              sortBy: 'POPULAR',
              orderBy: 'DEFAULT',
              filterBy: []
            }
          });
          _this2.loading = false;
          var {
            products,
            total: totalProducts
          } = productSearchSuggest;
          var categories = categorySearch;
          var total = products.length + categories.length;
          _this2.results = {
            query: _this2.search,
            products,
            categories,
            total,
            totalProducts
          };
        } catch (e) {
          _this2.loading = false;

          _this2.$logger.error(e);
        }
      })();
    }

  },

  render() {
    return this.$scopedSlots.default({
      keyword: this.search,
      data: this.results,
      loading: this.loading
    });
  }

};